<template>
  <el-form :inline="true" class="mainSearch">
    <el-page-header @back="goback" style="margin-bottom: 20px">
      <template #content>
        <span class="text-large font-600 mr-3">导入订单销售价 </span>
      </template>
    </el-page-header>
  </el-form>
  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
      <el-upload
        class="upload-demo"
        drag
        action="/api/order/importprice"
        :auto-upload="true"
        :headers="headerUpload"
        :on-success="doUploadSuccess"
        :before-upload="beforeUpload"
        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        name="file"
      >
        <el-icon class="el-icon--upload"><upload-filled /></el-icon>
        <div class="el-upload__text">
          拖动Excel文件 或者 <em>点击上传</em>
        </div>
        <template #tip>
          <div class="el-upload__tip">
            请上传xls,xlsx后缀名且小于2M的文件。
          </div>
        </template>
      </el-upload>      
      <div><el-link type="danger" href="/importTemplate/orderPriceTemplate.xlsx">下载订单销售价模板</el-link></div>
    </el-col>
    <el-col :span="24" class="mpadding" style="text-align:center">
        <div v-html="resultMsg"></div>
        <el-link v-if="filefail" @click="doDownload" :underline="false" type="danger"><el-icon class="iconcolor" ><Download/></el-icon>下载失败数据</el-link>
    </el-col>
  </el-row>
</template>
  <script setup>
import { useRouter } from "vue-router";
import { ref,onMounted } from "vue";
import { ElMessage } from "element-plus";
import { download } from "@/api/common";


import store from "@/store";

//返回
const router = useRouter();
const goback = () => {
  router.go(-1);
};


const filefail = ref("");
//文件下载
const doDownload = ()=>{
    download({fileName:filefail.value}).then((res)=>{
        let fileNameArr = (filefail.value).split('.');
        // let fileName = filefail.value+'.'+fileNameArr[1];
        let fileName = '订单销售价导入出错数据'+filefail.value.replace(/[^0-9]/ig, '')+'.'+fileNameArr[1];
        const blob = new Blob([res.data]);
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放URL 对象
        document.body.removeChild(elink);
    })
}

const resultMsg = ref();
const doUploadSuccess = (response) => {  
  if (response.code === 0) {    
    ElMessage.error(response.msg)
  } else {
    let res = (response.extend.order).split('||')
    // console.log(res)
    if (res[1]) {
      resultMsg.value = res[0]
      filefail.value = res[1]
    } else {
      resultMsg.value = res[0]
    }
    //resultMsg.value = response.extend.order
  }
};
const beforeUpload = (rawFile) => {
  if (rawFile.type !== 'application/vnd.ms-excel' && rawFile.type !=='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    ElMessage.error('请上传Excel文件!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('请上传小于2MB的文件!')
    return false
  }
  return true
}
const headerUpload = ref({
  Authorization: store.state.user.token,
});

//onMounted方法
onMounted(() => {
  //详情
});

</script>